export default __webpack_public_path__ + "static/media/video.707cd3cb.svg";